import type { LOCALES } from './constants.models';

// ? add other config property types here
declare global {
  interface Window {
    appConfig: IAppConfig;
    dtrum?: DynatraceRUM;
    dT_?: unknown;
    PriOIDCConfig?: {
      provider: string;
    };
    Q_curl?: unknown;
    Q_ci?: unknown;
    Q_cenv?: unknown;
    dataLayer?: object[];
    BrowserAgentExtension?: {
      logTextMetric?: (params: { key: string; value: string }) => void | undefined;
      setCustomerId?: (params: { customerId: string | number | null }) => void;
    };
  }
}

export interface DynatraceRUM {
  enterAction: (actionName: string, actionType: string) => string;
  leaveAction: (actionId: string) => void;
  reportError: (err: string, parentActionId: string) => void;
  reportCustomError: (
    key: string,
    value: string,
    hint?: string,
    parentingInfo?: number | boolean
  ) => void;
  identifyUser: (value: string) => void;
}

export enum Environment {
  DEV = 'dev',
  PROD = 'prod',
  TEST = 'test',
}

export interface Auth {
  defaultProvider: keyof Auth['providers'];
  refreshXSecondsBeforeExpiration?: number;
  redirectUriBase: string;
  registrationUrl: string;
  providers: Record<string, Provider>;
}

export interface Provider {
  tokensUrl: string;
  authorizeUrl: string;
  clientId: string;
  scope: string;
  discoveryUrl: string;
  issuerUrl: string;
}

export interface AuthToken {
  id_token?: string;
  expires_in?: number;
  access_token?: string;
  refresh_token?: string;
}

export interface IAppConfigEndpoints {
  [key: string]: string;
  bff: string;
  cm: string;
  rightanswerslink: string;
  rightanswerslinkpostjune2025: string;
  frRightanswerslinkpostjune2025: string;
}

export interface IAppConfigFeature {
  flag: boolean;
  feature: string;
}

export interface IAppConfigEcommConsent {
  ecommunication_consent: string;
}
export interface IAppConfigEcomm {
  en_CA: IAppConfigEcommConsent;
  fr_CA: IAppConfigEcommConsent;
  en_US: IAppConfigEcommConsent;
}
export interface IAppConfigLife {
  // rightAnswers: string;
  editBeneficiaryCanada: string;
  US_Irrevocable_change_form: string;
  Canada_French_Irrevocable_change_form: string;
  Canada_English_Irrevocable_change_form: string;
  Annuity_Withdrawal_US_en: string;
  Annuity_Withdrawal_CA_en: string;
  Annuity_Withdrawal_CA_fr: string;
  Policy_Owner_Name_Change_fr: string;
  Policy_Owner_Name_Change_en: string;
}

export interface IAppConfigInvestments {
  /* bnyLogin: string; // "https://primerica.impress-net.com/secure/login.asp",
  learnMore: {
    video1: string; // "https://www.youtube.com/embed/loh01LMQ9oo?rel=0&amp;showinfo=0",
    video2: string; // "https://www.youtube.com/embed/wcC8dISgIes?rel=0&amp;showinfo=0",
    video3: string; // "https://www.youtube.com/embed/WFLVoMuFHjU?rel=0&amp;showinfo=0",
    video4: string; // "https://www.youtube.com/embed/11aeIUOd98M?rel=0&amp;showinfo=0"
  }, */
  social_security_benefits: {
    ca: string; // "https://www.canada.ca/en/services/benefits/publicpensions/cpp/retirement-income-calculator.html",
    us: string; // "https://www.ssa.gov/benefits/retirement/estimator.html"
  };
  how_do_we_calculate: {
    less5years: string; // "/bltce87e5afdf066966/MISC-002.pdf",
    over5years: string; // "/blte5343755585baa5d/MISC-003.pdf"
  };
  important_disclosures: {
    us: string; // "/blt4f95024a4ef28f56/MISC_IMPORTANT_DISCLOSURE_US_8_19_2021.pdf",
    ca: string; // "/blt4a7acb12829d2918/MISC-010.pdf"
  };
  available_products: {
    en_US: Record<string, unknown>;
    es_US: Record<string, unknown>;
    en_CA: Record<string, unknown>;
    fr_CA: Record<string, unknown>;
  };
  /* rightAnswers: {
    us: string; // "https://primericastg.rightanswers.com/portal/app/portlets/results/viewsolution.jsp?solutionid=210217133048927&page=1&position=2&q=fund"
  } */
}
export interface IAppConfig {
  maxNotificationsToShow: number;
  env: Environment;
  pathName: string;
  techSupportPhone: string;
  showBootstrapErrors: boolean;
  endpoints: IAppConfigEndpoints;
  auth: Auth;
  features: IAppConfigFeature[];
  languagePreferences: LOCALES[];
  ecomm: IAppConfigEcomm;
  life: IAppConfigLife;
  content_stack: string;
  investments: IAppConfigInvestments;
  reinstatement: {
    override: boolean;
  };
  help: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
    authenticated: string;
    anonymous: string;
    enabled: boolean;
  };
  policyDocumentForms: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  };
  payments: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
    ca: {
      kubraLink: string;
    };
    us: {
      kubraLink: string;
    };
    disableAccountHolderNameEdit: boolean;
  };
}
